module.exports = __webpack_public_path__ + "img/ic_moveBlue.0a8a8a79.svg";